import { useQuery } from "@tanstack/react-query";
import { searchGamesIndex } from "entities/game/constants";
import { Game } from "entities/game/types";
import { formatAlgoliaHits } from "shared/utils/formatAlgoliaHits";

type UseSelectedGamesInModuleQueryProps = {
  moduleId: string | null;
  filters: string;
};

export const useSelectedGamesInModuleQuery = ({
  moduleId,
  filters,
}: UseSelectedGamesInModuleQueryProps) => {
  return useQuery({
    queryKey: ["selectedGamesInModule", moduleId, filters],

    queryFn: async () => {
      if (!filters.length) {
        return [];
      }

      const { hits } = await searchGamesIndex.search<Game>("", {
        filters,
        hitsPerPage: 1000,
      });

      return formatAlgoliaHits<Game>(hits);
    },
  });
};
